import { render, staticRenderFns } from "./Freshwater_fish.vue?vue&type=template&id=76b23960&scoped=true"
import script from "./Freshwater_fish.vue?vue&type=script&lang=js"
export * from "./Freshwater_fish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b23960",
  null
  
)

export default component.exports